const Auth = {
  login: '/auth/pharmacy/login',
  reset: '/user/reset/password',
  logout: '/auth/logout',
}

export default Auth;